// Very simple helper functions with no dependencies on imported functions

/** Check for both null and undefined * */
export const isVoid = (item) => item === null || item === undefined;

/**
 * Useful for checking whether a string has any value or is empty
 * Now works with arrays too.
 * Avoids accidentally checking falsy values like 0
 * */
export const isEmpty = (item) => {
  if (item === null || item === undefined) {
    return true;
  }

  // False boolean TODO I'm unsure if we want to consider this "empty" since it is a valid value.
  // The problem is there are some cases where we might get a string from the api that returns a false boolean on empty state
  if (typeof item === 'boolean' && item === false) {
    return true;
  }

  // empty object
  if (Object.getPrototypeOf(item) === Object.prototype) {
    return item && Object.keys(item).length === 0;
  }

  // empty array
  if (item.constructor === Array) {
    return item?.length === 0;
  }

  // empty string
  return item === '';
};
